import { LARGE_INPUT_LABEL_CLASS_NAME } from '../../../theme/constants/input-label';

const CONTRACT_INPUT_LABEL_PROPS = {
  className: LARGE_INPUT_LABEL_CLASS_NAME,
  shrink: true,
};

export default CONTRACT_INPUT_LABEL_PROPS;
